module.exports = {
	colors: {
		main: '#314da1',
		sec: '#e12734',
		alt: '#314da1',
	},

	showFunds: false,
	showBuses: false,
	showHomeworks: true,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963993327106', '+963993327101'],
		phones: ['0212220752', '0212246760', '0212246760'],
		address: 'حلب - المحافظة - خلف مدرسة مريم',
		data: [36.205419, 37.142509],
		branches: [
			{
				name: 'الفرع الرئيسي (يضم الروضة)',
				location: {
					url: null,
					name: 'الشهباء الجديدة - شارع أكاسيا'
				},
				numbers: [
					{ name: null, phone: '+963956702708' },
					{ name: null, landline: '0212668885' },
				],
			},
			{
				name: 'الفرع الثاني (الابتدائي والإعدادي)',
				location: {
					url: null,
					name: 'الشهباء القديمة - شارع المنظمات'
				},
				numbers: [
					{ name: null, phone: '+963938501000' },
					{ name: null, landline: '0212665665' },
				],
			},
		],
		email: null,
		facebook: 'https://www.facebook.com/share/1BJHpJRhh7/?mibextid=wwXIfr',
		privacy: 'https://api.almarah-school.edunixsystem.com/privacy-policy/index.html',
		details: [
			{
				title: 'عن مدرسة المرح الخاصة',
				content: [
					'تلتزم مدرسة المرح الخاصة، بقيادة فريق من التربويين المؤهلين والمخلصين، بتقديم الحلول التعليمية الأكثر فعالية وابتكارًا لضمان التميز الأكاديمي والنمو الشخصي المتكامل لطلابها.',
					'ومن خلال دمج المناهج القائمة على البحث العلمي مع أحدث التقنيات الرقمية، نعمل باستمرار على تقييم وتطوير العملية التعليمية لتحقيق أفضل النتائج الممكنة لطلابنا.',
				],
			},
			{
				title: 'هدفنا',
				content: [
					'تنمية الإبداع والتفكير النقدي والتميز الأكاديمي لدى طلابنا، وتمكينهم من بلوغ أعلى مراتب النجاح والتفوق.',
				],
			},
			{
				title: 'رسالتنا',
				content: [
					'إعداد جيلٍ متعلمٍ ومؤهلٍ علميًا، واثقٍ من نفسه، متعاونٍ، وقادرٍ على القيادة بالعلم والمسؤولية والنزاهة.',
				],
			},
			{
				title: 'شعارنا',
				content: [
					'معًا نُعلّم، معًا نبني المستقبل، ومعًا نُلهم جيلًا واعدًا بالنجاح.',
				],
			},
			{
				title: 'غايتنا',
				content: [
					'نجاح طلابنا هو انعكاسٌ لنجاحنا.',
				],
			},
		],
	},

	pwa: {
		name: 'Edunix',
		shortName: 'Edunix',
		description: 'Edunix app - portal version for edunix mobile app.',
	},
};
